import { useEffect, useState } from "react";
import Select from "react-select";
import {
  fetchFasesTrabajo,
  createTipoParametrosTrabajo,
  getTiposParametros,
  getCategoriasReportes,
  updateTipoParametrosTrabajo,
} from "../../components/functions/Projects";
import LoaderDialog from "../../ui/loader/Loader";
import { DialogActions, Typography, Dialog, Snackbar } from "@mui/material";
import CustomButton from "../../ui/button/Button";

const EDTParametroModal = ({
  API_URL,
  open,
  handleClose,
  selectedEDT,
  edit = false,
  parametro = null,
  selectedFaseDeTrabajo = null,
}) => {
  const [showLoader, setShowLoader] = useState(false);
  const [showSnackbar, setShowSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");

  const [fasesDeTrabajo, setFasesDeTrabajo] = useState([]);
  const [tiposParametros, setTiposParametros] = useState([]);
  const [categoriasReportes, setCategoriasReportes] = useState([]);

  const [parametroForm, setParametroForm] = useState({
    nombre: "",
    orden: null,
    tipoParametro: null,
    listaParametro: null,
    categoriaParametro: selectedFaseDeTrabajo,
    tipoTrabajo: {
      id: null,
    },
    categoriaReporte: null,
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        setShowLoader(true);

        const [fasesRes, tiposRes, categoriasRes] = await Promise.all([
          fetchFasesTrabajo(API_URL, selectedEDT.id),
          getTiposParametros(API_URL),
          getCategoriasReportes(API_URL, selectedEDT.id),
        ]);

        fasesRes.forEach((fase) => {
          if (fase.descripcion === "Entregable") {
            fase.descripcion = "Implementación";
          }
        });

        setFasesDeTrabajo(fasesRes);
        setTiposParametros(tiposRes);
        setCategoriasReportes(categoriasRes);

        setShowLoader(false);
      } catch (error) {
        setShowLoader(false);
        setSnackbarMessage("Ocurrió un error al obtener los datos.");
      }
    };
    if (open && selectedEDT) {
      if (edit && parametro) {
        setParametroForm({
          ...parametro,
        });
      } else {
        setParametroForm((prev) => ({
          nombre: "",
          orden: null,
          tipoParametro: null,
          listaParametro: null,
          categoriaParametro: selectedFaseDeTrabajo,
          tipoTrabajo: {
            id: selectedEDT.id,
          },
          categoriaReporte: null,
        }));
      }

      fetchData();
    }
    // eslint-disable-next-line
  }, [open, selectedEDT]);

  const onClose = () => {
    handleClose();
    setParametroForm((prev) => ({
      nombre: "",
      orden: null,
      tipoParametro: null,
      listaParametro: null,
      categoriaParametro: null,
      tipoTrabajo: {
        id: null,
      },
      categoriaReporte: null,
    }));
    setShowLoader(false);
  };

  async function crearParametro() {
    if (parametroForm.nombre.trim() === "") {
      setShowSnackbar(true);
      setSnackbarMessage("El nombre de la categoría de imagen es obligatorio.");
      return;
    }
    if (parametroForm.categoriaParametro === null) {
      setShowSnackbar(true);
      setSnackbarMessage("La categoría de imagen es obligatoria.");
      return;
    }

    if (
      parametroForm.categoriaReporte === null &&
      categoriasReportes.length > 0
    ) {
      setShowSnackbar(true);
      setSnackbarMessage("La categoría de reporte es obligatoria.");
      return;
    }
    if (parametroForm.tipoParametro === null) {
      setShowSnackbar(true);
      setSnackbarMessage("El tipo de parámetro es obligatorio.");
      return;
    }

    if (parametroForm.categoriaParametro.descripcion === "Implementación") {
      parametroForm.categoriaParametro.descripcion = "Entregable";
    }

    try {
      setShowLoader(true);
      if (edit) {
        await updateTipoParametrosTrabajo(API_URL, parametroForm);
      } else {
        await createTipoParametrosTrabajo(API_URL, parametroForm);
      }
      setShowLoader(false);
      onClose();
    } catch (error) {
      setShowLoader(false);
      setShowSnackbar(true);
      setSnackbarMessage(
        `Ocurrió un error al ${edit ? "actualizar" : "crear"} el parámetro.`
      );
    }
  }

  return (
    <>
      <Dialog
        fullWidth={true}
        maxWidth={"sm"}
        onClose={onClose}
        open={open}
        disableEnforceFocus
        height={"500px"}
      >
        <Snackbar
          open={showSnackbar}
          autoHideDuration={3000}
          onClose={() => {
            setShowSnackbar(false);
            setSnackbarMessage("");
          }}
          message={snackbarMessage}
          anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
          slotProps={{
            content: {
              sx: {
                backgroundColor: "white",
                color: "#222",
                justifyContent: "center",
                textAlign: "center",
                fontWeight: "bold",
                fontSize: "16px",
                fontFamily: "Roboto, Arial, sans-serif",
              },
            },
          }}
        />
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            margin: "0 0 120px 0",
            padding: "12px",
          }}
        >
          <h2>{edit ? "Editar" : "Crear"} parámetro</h2>
          <label htmlFor="name2" className="form-label form-label-left">
            Nombre:
          </label>
          <input
            id="name2"
            className="form-input"
            type="text"
            name="nombre"
            placeholder="Ingresa el nombre..."
            value={parametroForm.nombre}
            onChange={(e) =>
              setParametroForm((prev) => ({ ...prev, nombre: e.target.value }))
            }
          />

          {edit && (
            <label
              htmlFor="categoriaImagen"
              className="form-label form-label-left"
            >
              Fase de trabajo:
            </label>
          )}

          {edit ? (
            <Select
              options={fasesDeTrabajo.map((fase) => ({
                value: fase.name,
                label: fase.descripcion,
              }))}
              onChange={(e) =>
                setParametroForm((prev) => ({
                  ...prev,
                  categoriaParametro: fasesDeTrabajo.find(
                    (fase) => fase.name === e.value
                  ),
                }))
              }
              placeholder="Fase de trabajo..."
              classNamePrefix="react-select"
              styles={{
                dropdownIndicator: (provided) => ({
                  ...provided,
                  color: "#62C776",
                  cursor: "pointer",
                }),
                indicatorSeparator: () => ({ display: "none" }),
                option: (provided, state) => ({
                  ...provided,
                  color: "#000",
                  backgroundColor: state.isSelected ? "#e0e0e0" : "white",
                  cursor: "pointer",
                  fontSize: "14px",
                }),
                control: (provided) => ({
                  ...provided,
                  cursor: "pointer",
                  fontSize: "14px",
                  marginBottom: "12px",
                }),
                menu: (provided) => ({ ...provided, height: "120px" }),
                menuList: (provided) => ({
                  ...provided,
                  height: "120px",
                  textAlign: "left",
                }),
              }}
              value={
                fasesDeTrabajo
                  .map((fase) => {
                    return {
                      value: fase.name,
                      label: fase.descripcion,
                    };
                  })
                  .find(
                    (option) =>
                      option.label ===
                      parametroForm?.categoriaParametro?.descripcion
                  ) || null
              }
              inputId="categoriaImagen"
            />
          ) : (
            <Typography sx={{ color: "#223d51", mb: "12px" }} variant="body1">
              Fase de trabajo: {selectedFaseDeTrabajo?.descripcion}
            </Typography>
          )}

          <label
            htmlFor="tipoParametroP"
            className="form-label form-label-left"
          >
            Tipo de parámetro:
          </label>
          <Select
            options={tiposParametros.map((tipo) => ({
              value: tipo.name,
              label: tipo.descripcion,
            }))}
            onChange={(e) =>
              setParametroForm((prev) => ({
                ...prev,
                tipoParametro: tiposParametros.find(
                  (tipo) => tipo.name === e.value
                ),
              }))
            }
            placeholder="Tipo de parámetro..."
            classNamePrefix="react-select"
            styles={{
              dropdownIndicator: (provided) => ({
                ...provided,
                color: "#62C776",
                cursor: "pointer",
              }),
              indicatorSeparator: () => ({ display: "none" }),
              option: (provided, state) => ({
                ...provided,
                color: "#000",
                backgroundColor: state.isSelected ? "#e0e0e0" : "white",
                cursor: "pointer",
                fontSize: "14px",
              }),
              control: (provided) => ({
                ...provided,
                cursor: "pointer",
                fontSize: "14px",
                marginBottom: "12px",
              }),
              menu: (provided) => ({ ...provided, height: "120px" }),
              menuList: (provided) => ({
                ...provided,
                height: "120px",
                textAlign: "left",
              }),
            }}
            value={
              tiposParametros
                .map((fase) => {
                  return {
                    value: fase.name,
                    label: fase.descripcion,
                  };
                })
                .find(
                  (option) =>
                    option.label === parametroForm?.tipoParametro?.descripcion
                ) || null
            }
            inputId="tipoParametroP"
          />

          <label
            htmlFor="categoriaReporteP"
            className="form-label form-label-left"
          >
            Categoría de reporte:
          </label>
          <Select
            options={categoriasReportes.map((cat) => ({
              value: cat.id,
              label: cat.nombre,
            }))}
            onChange={(e) =>
              setParametroForm((prev) => ({
                ...prev,
                categoriaReporte: categoriasReportes.find(
                  (cat) => cat.id === e.value
                ),
              }))
            }
            placeholder="Categoría de reporte..."
            classNamePrefix="react-select"
            styles={{
              dropdownIndicator: (provided) => ({
                ...provided,
                color: "#62C776",
                cursor: "pointer",
              }),
              indicatorSeparator: () => ({ display: "none" }),
              option: (provided, state) => ({
                ...provided,
                color: "#000",
                backgroundColor: state.isSelected ? "#e0e0e0" : "white",
                cursor: "pointer",
                fontSize: "14px",
              }),
              control: (provided) => ({
                ...provided,
                cursor: "pointer",
                fontSize: "14px",
              }),
              menu: (provided) => ({ ...provided, height: "120px" }),
              menuList: (provided) => ({
                ...provided,
                height: "120px",
                textAlign: "left",
              }),
            }}
            value={
              categoriasReportes
                .map((cat) => {
                  return {
                    value: cat.id,
                    label: cat.nombre,
                  };
                })
                .find(
                  (option) =>
                    option.value === parametroForm?.categoriaReporte?.id
                ) || null
            }
            inputId="categoriaReporteP"
          />
        </div>
        <DialogActions>
          <CustomButton
            background={"#FFFFFF"}
            color={"#223D51"}
            text="Cerrar"
            height="40px"
            fontWeight="700"
            fontSize="14px"
            border="1px solid #D9D9D9"
            onClick={onClose}
            type="button"
          />
          <CustomButton
            background={"#223D51"}
            color={"#FFFFFF"}
            text="Guardar"
            height="40px"
            fontWeight="700"
            fontSize="14px"
            border="1px solid #D9D9D9"
            onClick={() => {
              crearParametro();
            }}
            type="button"
          />
        </DialogActions>
      </Dialog>
      <LoaderDialog open={showLoader} />
    </>
  );
};

export default EDTParametroModal;
